<template>
<div id="toast-container" v-show="isShow">
  <div class="toast-content-container">
    <i class="iconfont" :class="icon"></i>
    <span class="totast-content">{{msg}}</span>
  </div>
</div>
</template>

<script>
export default {
  name: 'toast',
  props: {
    icon: {
      type: String,
      default: ''
    },
    msg: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
#toast-container {
  width: 200px;
  height: 70px;
  position: fixed;
  z-index: 9999;
  left: calc(50% - 100px);
  top: calc(50% - 35px);
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, .9);
}

.toast-content-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toast-content-container i {
  color: #2783f2;
  font-size: 30px;
  margin: 0 10px 0 0;
}

.toast-content-container span {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
}
</style>
